import TitleSubTitle from './TitleSubTitle';

export default TitleSubTitle;
